module.exports = __webpack_public_path__ + "static/media/litho_3.63a00b74.jpg";